module.exports = __webpack_public_path__ + "static/media/logos_try.19ec23c9.svg";